import { put, takeLatest } from 'redux-saga/effects'
import finishRegistration from '../api/finishTOTPRegistration'
import {
  finishTOTPRegistrationSucceeded,
  finishTOTPRegistrationFailed
} from '../../actions/setupMFATOTP'
import { addMfaMechanismSucceeded } from '../../actions/mfaSettings'
import { FINISH_TOTP_REGISTRATION } from '../../constants/action.types'
import { TOTP } from '../../constants/mfa'
import executeSaga from './helpers/executeSaga'

export function* finishTOTPRegistration({ request }, action) {
  const { registrationToken: totp_registration_token, otp } = action.payload

  yield executeSaga(
    request,
    { totp_registration_token, otp },
    () => [
      put(finishTOTPRegistrationSucceeded()),
      put(addMfaMechanismSucceeded({ mfaMechanism: TOTP }))
    ],
    error => put(finishTOTPRegistrationFailed({ errorCode: error.message }))
  )
}

export default function*({ request } = { request: finishRegistration }) {
  yield takeLatest(FINISH_TOTP_REGISTRATION, finishTOTPRegistration, {
    request
  })
}
